function BookingNotification({
    notification,
}) {

    if (!notification) return null;

    return (
        <div
            style={{
                ...styles.box,

                background:
                    notification.ok
                        ? "rgba(0,255,150,0.1)"
                        : "rgba(255,0,0,0.1)",

                border:
                    notification.ok
                        ? "1px solid rgba(0,255,150,0.3)"
                        : "1px solid rgba(255,0,0,0.3)",
            }}
        >
            {notification.msg}
        </div>
    );
}

const styles = {

    box: {
        padding: "15px",
        borderRadius: "12px",
        marginBottom: "20px",
        color: "#fff",
        textAlign: "center",
    },
};

export default BookingNotification;